const w = [
  { abbreviation: "en", language: "English", id: 1 },
  { abbreviation: "fr", language: "Français", id: 2 },
  { abbreviation: "es", language: "Español", id: 4 },
  { abbreviation: "zh", language: "中文", id: 3 }
];
function A(a, d) {
  return a && d ? `${a}, ${d}` : "N/A";
}
async function _({
  user: a,
  getUser: d = async () => ({ data: { data: { schools: { data: [] } } } }),
  getRoles: l = async () => ({ data: { data: [] } }),
  langs: m = w,
  env: o
}) {
  var N, p;
  const e = m.find((t) => t.abbreviation === a.preferred_language), g = a.role === "tutor" || a.role === "tutor-manager" ? "3-Service" : a.district_id;
  let r = "N/A";
  const s = [], i = [], c = !a.roles.some((t) => t !== "student");
  (await l()).data.data.forEach((t) => {
    a.roles.includes(t.name) && (i.push(t.name), s.push(t.id)), t.name === a.role && (r = t.id);
  });
  const { schools: { data: [n] } } = (await d(a.id, "schools.district")).data.data, u = o ? `${o.charAt(0).toUpperCase()}${o.slice(1)}` : "Unknown";
  window.pendo.initialize({
    visitor: {
      id: `${u}-${a.id}`,
      schoolId: (n == null ? void 0 : n.id) || "N/A",
      location: A(n == null ? void 0 : n.country_code, n == null ? void 0 : n.region_code),
      gradeId: a.grade_id || "N/A",
      gradeName: a.grade_name || "N/A",
      roleId: r,
      roleName: a.role,
      rolesId: s,
      rolesName: i,
      languageId: (e == null ? void 0 : e.id) || "N/A",
      languageName: (e == null ? void 0 : e.language) || "N/A",
      email: c ? null : a.email,
      username: c ? null : a.username,
      firstName: c ? null : a.firstName,
      lastName: c ? null : a.lastName
    },
    account: {
      id: `${g || ""}` ?? "N/A",
      districtName: ((p = (N = n == null ? void 0 : n.district) == null ? void 0 : N.data) == null ? void 0 : p.name) ?? "N/A",
      rostering: (n == null ? void 0 : n.synced_with) ?? "manual"
    }
  });
}
let f = Promise.resolve();
async function E({
  apiKey: a = process.env.VITE_PENDO_API_KEY,
  user: d,
  getUser: l,
  getRoles: m,
  langs: o = void 0,
  env: e = process.env.VITE_APP_ENV
}) {
  if (!a)
    throw new Error("Pendo misconfigured");
  return f = new Promise((g, r) => {
    async function s() {
      try {
        await _({ user: d, getUser: l, getRoles: m, langs: o, env: e }), g();
      } catch (i) {
        r(i);
      }
    }
    if (window.pendo)
      s();
    else {
      const i = document.createElement("script");
      i.src = `https://cdn.pendo.io/agent/static/${a}/pendo.js`, i.async = !0, i.onload = s, i.onerror = r, document.head.appendChild(i);
    }
  }), f;
}
export {
  E as initializePendo,
  f as pendoInitializedPromise
};
